export default "__VITE_PUBLIC_ASSET__b43775da__"